import React from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import { FLOOR_ORDER } from "helpers/floorOrder";

// Buyer (Aranan) ilan: kabul edilen bulunduğu kat aralığı (sıralı enum from-to).
// "X. kat ve üzeri" = En Az X seçip En Çok'u boş/üst sınır bırakmak.
// Redux: filters.bulunduguKatMin, filters.bulunduguKatMax (etiket) -> backend idx.
function FLBuyerBulunduguKatRange(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const min = filters?.bulunduguKatMin ?? "";
  const max = filters?.bulunduguKatMax ?? "";

  return (
    <div style={{ display: "flex", gap: 8, width: "100%" }}>
      <TextField
        select
        label="En Alt Kat"
        variant="outlined"
        margin="dense"
        fullWidth
        value={min}
        onChange={(e) =>
          props.editNewAdvertFilters("bulunduguKatMin", e.target.value)
        }
      >
        <MenuItem value="">
          <em>Seçiniz</em>
        </MenuItem>
        {FLOOR_ORDER.map((label) => (
          <MenuItem key={label} value={label}>
            {label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label="En Üst Kat"
        variant="outlined"
        margin="dense"
        fullWidth
        value={max}
        onChange={(e) =>
          props.editNewAdvertFilters("bulunduguKatMax", e.target.value)
        }
      >
        <MenuItem value="">
          <em>Seçiniz</em>
        </MenuItem>
        {FLOOR_ORDER.map((label) => (
          <MenuItem key={label} value={label}>
            {label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}

export default connect(null, { ...advertRedux.actions })(
  FLBuyerBulunduguKatRange
);
